import { Navigate, Route } from 'react-router-dom'
import { AlbumShellLayout } from '@/features/album/layouts/AlbumShellLayout'
import { UserProfileScreen } from './screens/UserProfile/UserProfileScreen'
import { UserConnectionsScreen } from './screens/UserConnections/UserConnectionsScreen'

/**
 * Profile feature routes — mounted inside album/routes.tsx's `AlbumDesignRoot`.
 *
 * /profile                      → redirects to /profile/me (own profile)
 * /profile/me                   own profile (resolves via localStorage userId)
 * /profile/me/connections       own followers — redirect to /connections
 * /profile/:userId              any user's profile
 * /profile/:userId/connections  full connection list for that user
 */
export const profileRouteElements = (
  <Route path='profile' element={<AlbumShellLayout />}>
    <Route index element={<Navigate to='me' replace />} />
    <Route path='me' element={<UserProfileScreen />} />
    <Route path='me/connections' element={<Navigate to='/connections' replace />} />
    <Route path=':userId' element={<UserProfileScreen />} />
    <Route path=':userId/connections' element={<UserConnectionsScreen />} />
  </Route>
)
